import React from 'react';
import PropTypes from 'prop-types';

import LoadMore from '../generalComponents/LoadMore';

import FeaturedItem from './FeaturedItem';


class FeaturedItems extends React.Component {

  renderLoadMoreButton = () => {
    const { allDataLoaded, isLoading, loadMore } = this.props;
    if (allDataLoaded) {
      return null;
    }

    return (
      <LoadMore
        isLoading={isLoading}
        loadMore={loadMore}
      />
    );
  };

  render() {
    const { featuredItems, typeOfListing } = this.props;

    return (
      <div className="content">
        <div className="container">
          <div className="content-grid-container">
            <div className="content-grid">
              {featuredItems.map((link, index) => (
                <FeaturedItem
                  key={link?.name || link?.title}
                  featuredItem={link}
                  type="featured"
                  typeOfListing={typeOfListing}
                />
              ))
              }
            </div>
          </div>
          {this.renderLoadMoreButton()}
        </div>
      </div>
    );
  }
}

export default FeaturedItems;

FeaturedItems.propTypes = {
  loadMore: PropTypes.func.isRequired,
  typeOfListing: PropTypes.string.isRequired,
  allDataLoaded: PropTypes.bool,
  featuredItems: PropTypes.array,
  isLoading: PropTypes.bool,
};

FeaturedItems.defaultProps = {
  featuredItems: [],
  isLoading: false,
  allDataLoaded: false,
};
